import React, {useState} from "react";
import moment from "moment";
import {Card, CardBody, Col, Form, FormGroup, Input, Label, Row, CardTitle} from 'reactstrap';
import {
    ButtonCancel,
    ButtonSubmit,
} from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";

import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/busPickupActions";
import BusPickupLangs from "./_langs";
import {connect} from "react-redux";
import { INTERNATIONAL } from "../../../components/i18n/i18n";

const BusPickupForm = props => {
    const { editMode, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [delay, setDelay] = useState(domainObject?.delay || "00:00");

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: domainObject?.code,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: data.code,
                delay: delay,
                langs: langs
            }
        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return <>
        <Card>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder="Codigo"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Tiempo de retraso</Label>
                                <Input type="time" name="delay"
                                       placeholder="Ingrese hora"
                                       value={delay}
                                       onChange={
                                           (e)=>setDelay( moment(e.target.value, 'HH:mm')._i )
                                       }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <BusPickupLangs langs={langs} setLangs={setLangs} />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    </>

}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(BusPickupForm)
